// import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';


// #region import

// import { ModalHelper } from './services/modal/modal.helper';/
// const HELPERS = [ModalHelper];

// components
const COMPONENTS = [];

// pipes

// #endregion

// #region all delon used icons

// - zorro: https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/components/icon/nz-icon.service.ts#L6


// #endregion

@NgModule({
  imports: [CommonModule, RouterModule],
  declarations: [...COMPONENTS,],
  exports: [...COMPONENTS,],
})
export class AlainThemeModule {
  constructor() {

  }

  static forRoot(): ModuleWithProviders {
    return {
      ngModule: AlainThemeModule,
      providers: [],
    };
  }

  static forChild(): ModuleWithProviders {
    return {
      ngModule: AlainThemeModule,
      providers: [],
    };
  }
}
